
import React from 'react'
import Landing from './components/Landing';


function App() {
  return (
    // <Footer />
    <Landing />
  )
}

export default App;
